export default {"src":"/_next/static/media/icone-aura.58e2ba44.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};